export const APP_MODE = {
  INTERIOR : "INTERIOR",
  VEHICLE  : "VEHICLE",
  OBJECT   : "OBJECT",
};

export const GA_CATEGORY = "App";

export const GA_ACTION = {
  LAUNCH       : "Launch",
  PLACE_OBJECT : "Place_Object",
  OBJECT_MODE  : "Object_Mode",
  PANO_VIEW    : "Pano_View"
};

export const APP_STAGE = {
  PRODUCTION: "production"
};
